module.exports = __webpack_public_path__ + "img/banner_closing.96eec0aa.jpg";